import { Record, List } from 'immutable'
import moment from 'moment'

const Attributes = Record({
  interactionId: undefined,
  delivery: "FOREVER",
  runUntil: undefined,
  senderId: undefined,
  messageType: "CHAT",
})

export const BotCampaign = Record({
  id: undefined,
  name: `LeadBot Campaign - created on ${ moment().format('LL') }`,
  type: "BOT",
  inboxId: undefined,
  audience: undefined,
  userListIds: List(),
  targetId: 0,
  attributes: Attributes(),
})

export const parseBotCampaign = ({ attributes, userListIds, ...rest }) => {
  return BotCampaign({
    userListIds: List(userListIds),
    attributes: Attributes(attributes),
    ...rest,
  })
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/campaigns/models.js